<div class="container-fluid">
  <div class="col-12 text-center mt-5">
    <h4 class="text-white">Seleziona un elemento,<br> scopri i contenuti.</h4>
  </div>
  <div class="row no-gutters mt-4">
    <app-interaction class="col-3" *ngFor="let interaction of interactions" [interaction]="interaction" [class.hideInteraction]="interaction.comingSoon"></app-interaction>
  </div>
</div>
<p class="text-center" *ngIf="interactionsOpened && interactionsOpened.length > 0">
  <a class="btn btn-outline-white mt-4 btn-rounded" (click)="clearCheck()">Azzera i progressi</a>
</p>
